import React from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { booksInfo } from "../../../../constants/books-info";
import StarsRow from "../StarsRow";
import ContentFooter from "./ContentFooter";
import Wip from "../../Wip";
import { useTheme } from "../../../../common/hooks";
import "./content.css";
import { useTranslation } from "react-i18next";

export default function BookContent(props) {
  const { technology } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();

  if (!booksInfo[technology]) {
    return <Wip />;
  }

  const svgString = encodeURIComponent(
    renderToStaticMarkup(booksInfo[technology].logo ?? "")
  );

  const backgroundImage = `url("data:image/svg+xml,${svgString}")`;

  return (
    <div className="book-container">
      <h1
        className="header"
        style={{
          backgroundColor: booksInfo[technology].color,
        }}
      >
        {booksInfo[technology].title.toUpperCase()}
      </h1>
      <div
        className="bg-icon"
        style={{
          backgroundImage,
          minHeight: "80vh",
        }}
      >
        <div
          className="overview bg-icon"
          style={{
            backgroundImage: backgroundImage,
            backgroundColor: theme.secondaryBackground,
          }}
        >
          {booksInfo[technology].overview.map((row, index) => (
            <StarsRow
              key={`${technology}-row-${index}`}
              title={t(row.title).toUpperCase()}
              value={row.value}
            />
          ))}
        </div>

        {booksInfo[technology].sections.map((row) => (
          <div key={`${technology}-${row.title}`} className="section">
            <h1 style={{ color: theme.primaryText }}>
              {t(row.title).toUpperCase()}
            </h1>
            <div className="section-content">
              {row.items.map((item) => (
                <div
                  className="book-item"
                  style={{
                    color: booksInfo[technology].color,
                  }}
                  onClick={() =>
                    item.url && window.open(item.url, "_blank").focus()
                  }
                >
                  {item.name.toUpperCase()}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <ContentFooter
        title={t("library.content.related-content")}
        content={booksInfo[technology].relatedContent}
        color={booksInfo[technology].color}
      />
    </div>
  );
}

BookContent.defaultProps = { technology: "javascript" };
